import { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import {
  encaixarAgendaApi,
  updateAgendaSituacaoApi,
  registrarPacienteFaltouApi,
} from '../services/agendaMutations';

const situacoesConhecidas = new Set([
  'Aberta',
  'Em Atendimento',
  'Reservada',
  'Feriado',
  'Fechada',
  'Faltou',
  'Solicitado',
  'Autorizado',
  'Atendido',
  'Cancelado',
  'Cancelada',
  'Marcada',
]);

const useAgendaActions = ({ dateAgendaFormatted, mutateAgendas }) => {
  const encaixeAgenda = useCallback(
    async agendaItem => {
      try {
        await encaixarAgendaApi(agendaItem, dateAgendaFormatted);
        await mutateAgendas();
      } catch (err) {
        toast.error(err?.response?.data?.error || 'Erro ao encaixar!');
      }
    },
    [dateAgendaFormatted, mutateAgendas]
  );

  const alteraStatusAgenda = useCallback(
    async (pAgenda, situacao) => {
      if (!pAgenda) return toast.warn('Agendamento não identificado!');

      if (!situacoesConhecidas.has(situacao)) {
        return toast.warn('Situação desconhecida!');
      }

      const status = situacao === 'Cancelada' ? 'Cancelado' : situacao;

      try {
        await updateAgendaSituacaoApi(pAgenda.CODAGENDA, status);

        await mutateAgendas();

        if (status === 'Faltou' && pAgenda.CODPAC !== 1) {
          await registrarPacienteFaltouApi(pAgenda);
        }

        if (situacao === 'Cancelado') {
          await encaixeAgenda(pAgenda);
        }
      } catch (err) {
        toast.error(err?.response?.data?.error || 'Erro interno!');
      }
    },
    [encaixeAgenda, mutateAgendas]
  );

  return useMemo(
    () => ({ encaixeAgenda, alteraStatusAgenda }),
    [encaixeAgenda, alteraStatusAgenda]
  );
};

export default useAgendaActions;
